import script from "./SearchableCombobox.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchableCombobox.vue?vue&type=script&setup=true&lang=js"

import "./SearchableCombobox.vue?vue&type=style&index=0&id=384d610c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384d610c"]])

export default __exports__